export const isFirstStepByStepNumber = (stepNumber: number): stepNumber is 0 =>
  stepNumber === 0
